'use client';

import React, { useState } from 'react';
import { useSearchParams } from 'next/navigation';
// import AppleLogo from '@/assets/apple-logo.svg';
import GoogleLogo from '@/assets/google-logo.svg';

import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AuthError } from '@supabase/auth-js';
import { useAppContext } from '@/context/app-context';
import { ROUTES } from '@/constants/routes';

export function SocialLogin() {
    const searchParams = useSearchParams();
    const priceId = searchParams.get('priceId');
    const coupon = searchParams.get('coupon');
    const [isGoogleLoading, setIsGoogleLoading] = useState(false);
    // const [isAppleLoading, setIsAppleLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const { logInWithSocial } = useAppContext();

    const handleGoogleSignIn = async () => {
        try {
            setIsGoogleLoading(true);

            // If priceId is present, redirect to checkout after social login
            let redirectPath;
            if (priceId) {
                const checkoutParams = new URLSearchParams({ priceId });
                if (coupon) {
                    checkoutParams.append('coupon', coupon);
                }
                redirectPath = `${ROUTES.CheckoutRedirect}?${checkoutParams.toString()}`;
            }

            await logInWithSocial('google', redirectPath);
            // TODO get token and call server action
        } catch (err) {
            setError(
                (err as AuthError).message ?? 'An unexpected error occurred',
            );
        } finally {
            setIsGoogleLoading(false);
        }
    };

    // const handleAppleSignIn = async () => {
    //     try {
    //         setIsAppleLoading(true);
    //         logInWithSocial('apple');
    //         // TODO get token and call server action
    //     } catch (err) {
    //         setError(
    //             (err as AuthError).message ?? 'An unexpected error occurred',
    //         );
    //     } finally {
    //         setIsAppleLoading(false);
    //     }
    // };

    return (
        <div className="flex flex-col items-center gap-4 w-full">
            <Button
                variant="outline"
                onClick={handleGoogleSignIn}
                disabled={
                    isGoogleLoading
                    // || isAppleLoading
                }
                loading={isGoogleLoading}
                className="gap-3 bg-neutral-850 border-neutral-600 w-full"
            >
                <GoogleLogo />
                Continue with Google
            </Button>

            {/*<Button*/}
            {/*    variant="outline"*/}
            {/*    onClick={handleAppleSignIn}*/}
            {/*    disabled={isAppleLoading || isGoogleLoading}*/}
            {/*    loading={isAppleLoading}*/}
            {/*    className="gap-3 bg-neutral-850 border-neutral-600 w-full"*/}
            {/*>*/}
            {/*    <AppleLogo />*/}
            {/*    Continue with Apple*/}
            {/*</Button>*/}

            {error && (
                <Alert variant="destructive" className="mb-4">
                    <AlertDescription>{error}</AlertDescription>
                </Alert>
            )}
        </div>
    );
}
